'use client';

import { useEffect, useState } from 'react';
import { toast } from 'sonner';

export const useOffline = () => {
  const [isOffline, setIsOffline] = useState<boolean>(false);
  const [snackId, setSnackId] = useState<string | number>('');

  useEffect(() => {
    const handleOfflineStatus = () => setIsOffline(!navigator.onLine);

    window.addEventListener('offline', handleOfflineStatus);
    window.addEventListener('online', handleOfflineStatus);

    return () => {
      window.removeEventListener('offline', handleOfflineStatus);
      window.removeEventListener('online', handleOfflineStatus);
    };
  }, []);

  useEffect(() => {
    if (snackId && !isOffline) {
      toast.dismiss(snackId);
      setSnackId('');
      toast.success('Conexão restabelecida');
    }
  }, [isOffline, snackId]);

  if (isOffline && !snackId) {
    const id = toast.warning(
      'Você está offline, por favor verifique sua conexão',
      {
        duration: Infinity,
      }
    );

    setSnackId(id);
  }

  return { isOffline };
};
